// extracted by mini-css-extract-plugin
module.exports = {"row":"_2bOgO","textNoMargin":"_1mQAE","textLineHeight":"uF-qm","preWrap":"_2les4","ellipsis":"_37-wu"};